import * as React from 'react';

const MediaSvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="media_svg__eds-icon--media_svg"
        x={0}
        y={0}
        viewBox="0 0 24 24"
        xmlSpace="preserve"
        {...props}
    >
        <path
            id="media_svg__eds-icon--media_base"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3 5h18v3h-2v1h2v2.5h-2v1h2V15h-2v1h2v3H3v-3h2v-1H3v-2.5h2v-1H3V9h2V8H3V5zm18-2v1H3V3H2v18h1v-1h18v1h1V3h-1z"
        />
        <path
            id="media_svg__eds-icon--media_play"
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10 8.3v7.2l5.7-3.9L10 8.3zm1 1.7l2.8 1.6-2.8 2V10z"
        />
    </svg>
);

MediaSvg.displayName = 'MediaSvg';
export default MediaSvg;
